module.exports = __webpack_public_path__ + "img/s (2).88fd491e.png";